/**
 * Copyright 2024 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */
import React from 'react';
import { IUserInfo } from 'src/types/interfaces/api.interface'

interface AppContextType {
  navStackLength: number;
  // 微信小程序环境检测
  isMiniProgram: boolean;
  setIsMiniProgram: (isMiniProgram: boolean) => void;
  isMiniProgramInitialized: boolean;
  setIsMiniProgramInitialized: (initialized: boolean) => void;
  // 全局用户信息
  userInfo: IUserInfo | null;
  setUserInfo: (userInfo: IUserInfo | null) => void;
  // 用户信息加载状态
  isUserInfoLoading: boolean;
  setIsUserInfoLoading: (loading: boolean) => void;
}

export const Context = React.createContext<AppContextType>({
  navStackLength: 1,
  // 微信小程序环境检测默认值
  isMiniProgram: false,
  setIsMiniProgram: () => {},
  isMiniProgramInitialized: false,
  setIsMiniProgramInitialized: () => {},
  // 全局用户信息默认值
  userInfo: null,
  setUserInfo: () => {},
  isUserInfoLoading: false,
  setIsUserInfoLoading: () => {},
});